import {useAuth} from 'react-oidc-context'
import {useGetUsersQuery} from '../../auth/AuthApiSlice'
import {CorrespondenceParticipantRole} from '../interfaces'
import {ICorrespondenceHost, IRecipientProviderResult} from './types'
import {IUserDetails} from '../../settings/interfaces/IUserDetails'

function mapRoleToParticipantRole(role?: string): CorrespondenceParticipantRole {
  if (!role) return CorrespondenceParticipantRole.Admin
  const r = role.toLowerCase()
  if (r === 'financier') return CorrespondenceParticipantRole.Financier
  if (r === 'grant provider') return CorrespondenceParticipantRole.GrantProvider
  if (r.includes('analyst')) return CorrespondenceParticipantRole.Analyst
  if (r.includes('manager')) return CorrespondenceParticipantRole.Manager
  return CorrespondenceParticipantRole.Admin
}

function useInternalRecipients(searchQuery: string): IRecipientProviderResult {
  const auth = useAuth()
  const {data, isLoading} = useGetUsersQuery(
    {page: 1, pageSize: 200},
    {skip: !auth.isAuthenticated}
  )

  const all: IUserDetails[] = data
    ? (Object.values(data.entities).filter(Boolean) as IUserDetails[])
    : []

  const q = searchQuery.toLowerCase().trim()
  const filtered = q
    ? all.filter(
        (u) =>
          `${u.firstName} ${u.lastName}`.toLowerCase().includes(q) ||
          u.email?.toLowerCase().includes(q)
      )
    : all

  return {
    recipients: filtered.map((u) => ({
      id: u.id,
      displayName: `${u.firstName} ${u.lastName}`.trim(),
      email: u.email,
      participantRole: mapRoleToParticipantRole(u.role),
    })),
    isLoading,
  }
}

export const internalHost: ICorrespondenceHost = {
  inboxRoute: () => '/correspondence',
  threadRoute: (id) => `/correspondence/${id}`,
  useRecipients: useInternalRecipients,
  getThreadDefaults: () => ({}),
  canStartThread: true,
  canReply: true,
}
